import { useCallback, useRef } from 'react';

const PAGING = new Set(['limit', 'offset']);

const isEmpty = (v: unknown) => v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0);

/** Remembers the query params of the page's last list request, minus paging, for export. */
export const useLastListParams = () => {
  const ref = useRef<Record<string, unknown>>({});
  const remember = useCallback(<T extends Record<string, unknown>>(params: T): T => {
    ref.current = Object.fromEntries(Object.entries(params).filter(([k, v]) => !PAGING.has(k) && !isEmpty(v)));
    return params;
  }, []);
  const getParams = useCallback(() => ref.current, []);
  return { remember, getParams };
};
